<div class="password-requirements" [ngClass]="{active: password}">
  <mat-progress-bar
    mode="determinate"
    [value]="progress"
  ></mat-progress-bar>
<!--  <div>-->
  <div *ngFor="let requirement of requirements" class="requirement animate__fadeInDownBig">
    <span class="icon">
      <mat-icon *ngIf="requirement.isValid" color="primary">done</mat-icon>
      <mat-icon *ngIf="!requirement.isValid" color="warn">error</mat-icon>
    </span>
    {{ requirement.message }}
  </div>
<!--  </div>-->
</div>
